import { ApiResponse, TokenData, IExcessAmountAdjustmentType } from '../models';
import * as http from './http';
import ApiService from './service';

export class ExcessAmountAdjustmentTypeService extends ApiService {
  public async loadAllExcessAmountAdjustmentTypes(): Promise<
    IExcessAmountAdjustmentType[]
  > {
    const url = `${this.apiDomain}/api/excess-amount-adjustment-type`;

    const resposne = await http.get<ApiResponse<IExcessAmountAdjustmentType[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async updateExcessAmountAdjustmentType(
    data: IExcessAmountAdjustmentType,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/excess-amount-adjustment-type/${id}`;

    const response = await http.put<ApiResponse<IExcessAmountAdjustmentType>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createExcessAmountAdjustmentType(
    data: IExcessAmountAdjustmentType
  ) {
    const url = `${this.apiDomain}/api/excess-amount-adjustment-type`;

    const response = await http.post<ApiResponse<IExcessAmountAdjustmentType>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteExcessAmountAdjustmentType(id?: string) {
    const url = `${this.apiDomain}/api/excess-amount-adjustment-type/${id}`;

    const response = await http.remove<
      ApiResponse<IExcessAmountAdjustmentType>
    >(url, this.store);
    return response.data;
  }
}
